// extracted by mini-css-extract-plugin
export var infoRow = "_pb-2";
export var labelContainer = "_pb-0";
export var rightInfo = "_pb-1";